import { Paper, Typography, Grid } from "@mui/material";
import { Box } from "@mui/material";
import { text } from '../context/aboutText'

function About() {
  function importAll(r) {
    let images = {};
     r.keys().forEach((item, index) => { images[item] = r(item); });
    return images
   }

  const nra_images = importAll(require.context('../images/funding_partners/'))
  const partner_images = importAll(require.context('../images/project_partners/'))

  return (
    <Box maxWidth='1000px' sx={{ margin: 'auto', padding: 'auto' }}>
      <Paper sx={{ padding: 4 }}>

        <Typography variant="h4" pb={2}>{text.title}</Typography>

        <Typography paragraph>
          {text.aimText} <a href={text.aimlink}>{text.aimLinkText}</a>.
        </Typography>

        <Typography paragraph>
          {text.websiteDeliverableText}
        </Typography>

        <Typography paragraph>
          {text.participatingNRAsText}
        </Typography>

        <br />

        <Grid container spacing={1} justifyContent={'center'}>
            {Object.keys(nra_images).map((keyname, i) => (
              <Grid item key={i}>
                <img src={nra_images[keyname]} alt={keyname} height='60px'/>
              </Grid>
            ))}
        </Grid>

        <br />

        <Typography paragraph>
          <b>{text.projectPartnersBold}</b> {text.projectPartnersText}
        </Typography>

        <br />

        <Grid container spacing={1} justifyContent={'center'}>
            {Object.keys(partner_images).map((keyname, i) => (
              <Grid item key={i}>
                <img src={partner_images[keyname]} alt={keyname} height='60px'/>
              </Grid>
            ))}
        </Grid>

        <Typography paragraph>
          <b>{text.CEDRBold}</b> {text.CEDRText1}<a href={text.CEDRLink}>{text.CEDRLink}</a>{text.CEDRText2}
        </Typography>

      </Paper>
    </Box>


  );
}

export default About;
